export default __webpack_public_path__ + "static/media/move-arte-9.576753f4.webp";